import type { DealTask } from './dealTasks';

/**
 * The date the Deal Card's Next action row offers: "Nearest open task".
 *
 * The earliest due date among OPEN tasks that have one. Undated tasks are
 * skipped, unlike leadNextAction.ts, because that names a task and this
 * offers a date. A past date is still offered: the task is overdue, not gone.
 * Null, and the offer is hidden, when there is nothing dated or when Next
 * action already says that date. It only offers; the drawer writes on a click.
 */
export function nearestOpenTaskDate(
  tasks: Pick<DealTask, 'due_date' | 'is_completed'>[],
  nextActionDate: string | null,
): string | null {
  let nearest: string | null = null;
  for (const task of tasks) {
    if (task.is_completed || task.due_date === null) continue;
    if (nearest === null || task.due_date < nearest) nearest = task.due_date;
  }
  return nearest === nextActionDate ? null : nearest;
}
